{
  "title": "Configuration",
  "subtitle": "Les listes et les règles qui définissent le fonctionnement de l'application. Les responsables peuvent les consulter, seuls les administrateurs peuvent les modifier.",
  "savedRules": "Paramètres enregistrés",
  "nav": {
    "label": "Sections de la configuration",
    "rules": "Règles",
    "lists": "Listes",
    "sales": "Ventes",
    "stock-rules": "Règles de stock",
    "alert-settings": "Paramètres des alertes",
    "document-numbers": "Numérotation",
    "document-print": "Documents imprimés",
    "labels": "Étiquettes code-barres",
    "languages": "Langues",
    "tax-rates": "Taux de TVA",
    "price-lists": "Listes de prix",
    "channels": "Canaux de vente",
    "carriers": "Transporteurs",
    "units": "Unités de mesure",
    "adjustment-reasons": "Motifs d'ajustement",
    "options": "Options de produits",
    "attributes": "Attributs de produits",
    "sales-rules": "Règles de vente",
    "cash-registers": "Caisses",
    "online-store": "Boutique en ligne",
    "supplier-payment-methods": "Modes de paiement fournisseurs"
  },
  "stockRules": {
    "title": "Règles de stock",
    "negativeQuestion": "Quand une opération rendrait le stock négatif",
    "recommended": "recommandé",
    "allow": {
      "title": "Autoriser, après confirmation",
      "text": "La personne doit confirmer, c'est enregistré et les responsables reçoivent une alerte."
    },
    "block": {
      "title": "Bloquer",
      "text": "L'opération ne peut pas être validée tant que le stock est insuffisant."
    },
    "quickTransfers": {
      "title": "Transferts rapides",
      "text": "Autoriser les transferts en une étape entre sites pour les personnes ayant la permission « Transfert rapide »."
    },
    "threshold": {
      "title": "Corrections soumises à un responsable",
      "text": "Les ajustements d'une valeur supérieure attendent l'approbation d'un responsable."
    },
    "costing": {
      "title": "Méthode de valorisation",
      "text": "Chaque produit a un coût moyen unique, mis à jour à chaque entrée. Fixe dans cette version.",
      "value": "Coût moyen pondéré"
    }
  },
  "alerts": {
    "title": "Paramètres des alertes",
    "subtitle": "Utilisés par le moteur d'alertes de la phase 5.",
    "deadStock": "Stock dormant après",
    "transferLate": "Transfert en retard après",
    "countVariance": "Alerte d'écart d'inventaire au-delà de",
    "digest": "Email récapitulatif quotidien à"
  },
  "numbers": {
    "title": "Numérotation des documents",
    "subtitle": "Les numéros suivent PRÉFIXE-ANNÉE-COMPTEUR ; le compteur repart à zéro chaque année.",
    "operation": "Opération",
    "prefix": "Préfixe",
    "nextCounter": "Prochain compteur",
    "nextNumber": "Prochain numéro",
    "prefixOf": "Préfixe de {{type}}",
    "saved": "Préfixe enregistré",
    "transactionNote": "Les numéros du journal d'activité ({{example}}) sont fixes : ils identifient des enregistrements qui ne changent jamais.",
    "types": {
      "stockIn": "Entrée de stock",
      "stockOut": "Sortie de stock",
      "adjustment": "Ajustement",
      "openingStock": "Stock initial",
      "transfer": "Transfert",
      "count": "Inventaire",
      "transaction": "Journal d'activité",
      "productImport": "Import de produits",
      "invoice": "Facture",
      "creditNote": "Avoir",
      "supplierPayment": "Paiement fournisseur"
    }
  },
  "languages": {
    "title": "Langues",
    "subtitle": "Les langues que chacun peut choisir pour l'interface.",
    "default": "Par défaut",
    "note": "La langue par défaut, choisie dans le profil de l'entreprise, reste toujours activée."
  },
  "taxRates": {
    "title": "Taux de TVA",
    "subtitle": "Chaque article a un taux de TVA ; les prix sont saisis TTC et les tickets détaillent la TVA par taux.",
    "add": "Ajouter un taux",
    "edit": "Modifier le taux",
    "name": "Nom",
    "rate": "Taux",
    "ratePercent": "Taux (%)",
    "rateHint": "0 pour les articles exonérés, jusqu’à {{max}}, deux décimales au plus.",
    "default": "Par défaut",
    "makeDefault": "Mettre par défaut",
    "madeDefault": "{{name}} est maintenant le taux par défaut",
    "empty": "Aucun taux de TVA. Ajoutez les taux que vous facturez, par exemple 19 %, 7 % et exonéré."
  },
  "priceLists": {
    "title": "Listes de prix",
    "subtitle": "Une liste pour les comptoirs, une pour la boutique en ligne, une pour les ventes en gros. Les prix sont TTC.",
    "name": "Liste de prix",
    "prices": "Prix",
    "channels": "Utilisée par",
    "base": "Le prix de vente de chaque article",
    "ownOrBase": "Son propre prix, sinon le prix de vente",
    "none": "Aucun canal",
    "rename": "Renommer",
    "renameTitle": "Renommer la liste de prix",
    "rule": "Un article sans prix en ligne se vend en ligne à son prix de vente. Un article sans prix de gros n'est pas vendu en mode gros. Saisissez ces prix sur la fiche article.",
    "ownOnly": "Son propre prix seulement : sans lui, pas vendu en gros"
  },
  "channels": {
    "title": "Canaux de vente",
    "subtitle": "Où se font les ventes : le comptoir de chaque magasin, la boutique en ligne et le back-office.",
    "channel": "Canal",
    "numbers": "Prochaine commande",
    "priceList": "Liste de prix",
    "payment": "Paiement",
    "off": "Désactivé",
    "atSite": "À {{name}}",
    "fromSite": "Préparé à {{name}}",
    "noFulfillmentSite": "Pas encore de site de préparation",
    "anySite": "Site choisi à chaque commande",
    "withCarrier": "expédie avec {{name}}",
    "rule": "Chaque magasin reçoit son canal comptoir à sa création. La boutique en ligne ouvre dès qu’elle a un site de préparation.",
    "editTitle": "Modifier {{name}}",
    "typeHints": {
      "pos": "Ventes au comptoir de ce magasin, payées sur place.",
      "online": "Commandes de la boutique en ligne, préparées sur un site, livrées ou retirées.",
      "backOffice": "Commandes prises par téléphone ou par l’équipe, pour tout site."
    },
    "activeLabel": {
      "pos": "Vendre à ce comptoir",
      "online": "Prendre les commandes en ligne",
      "backOffice": "Prendre les commandes du back-office"
    },
    "activeHint": {
      "pos": "Désactivé : les caisses de ce magasin ne peuvent pas vendre.",
      "online": "Nécessite un site de préparation et un mode de livraison.",
      "backOffice": "Désactivé : l’équipe ne peut pas créer de commandes."
    },
    "name": "Nom",
    "prefix": "Préfixe des commandes",
    "prefixHint": "Les commandes sont numérotées {{example}}.",
    "priceListHint": "Les prix auxquels ce canal vend.",
    "paymentMethods": "Moyens de paiement",
    "onlinePaymentLater": "Le paiement par carte sur le site arrive avec un prestataire de paiement (phase ultérieure).",
    "fulfillmentSite": "Site de préparation",
    "fulfillmentHint": "Son stock est réservé puis sorti pour ces commandes.",
    "defaultSite": "Site par défaut",
    "defaultSiteHint": "Proposé sur les nouvelles commandes ; chaque commande peut utiliser un autre site.",
    "noSite": "Aucun site",
    "deliveryModes": "Livraison",
    "deliveryHints": {
      "shipping": "Envoyée à l’adresse du client.",
      "pickup": "Retirée par le client sur un point de retrait."
    },
    "pickupSites": "Points de retrait",
    "pickupHint": "Où les clients peuvent retirer leurs commandes.",
    "noSites": "Aucun site actif. Créez d’abord vos sites dans Emplacements.",
    "steps": "Étapes de préparation",
    "stepsHint": "Les commandes passent par ces étapes avant d’être remises.",
    "reservation": "Réservation du stock",
    "reservationHint": "Une commande non payée garde son stock pendant cette durée ({{min}} à {{max}} minutes).",
    "minutes": "min",
    "saved": "{{name}} enregistré",
    "returnDays": "Délai de retour",
    "returnDaysHint": "Jours après la remise pendant lesquels les articles peuvent revenir (0 à {{max}}). Un responsable peut accepter un retour plus tardif.",
    "days": "jours",
    "shippingFee": "Frais de livraison",
    "shippingFeeHint": "Ajoutés aux commandes livrées de la boutique en ligne, TTC.",
    "defaultCarrier": "Transporteur par défaut",
    "defaultCarrierHint": "Les commandes à livrer de ce canal partent avec lui, sauf si un autre transporteur est choisi.",
    "noCarriers": "Aucun transporteur pour l’instant : ajoutez-les dans Transporteurs, plus bas.",
    "noCarrier": "Aucun : choisi à l’expédition"
  },
  "lists": {
    "rule": "Une valeur utilisée peut seulement être désactivée. Les valeurs inutilisées peuvent être supprimées.",
    "usage": "Utilisé par",
    "notUsed": "Non utilisé",
    "usedBy_one": "{{count}} produit",
    "usedBy_many": "{{count}} produits",
    "usedBy_other": "{{count}} produits",
    "inactive": "Inactif",
    "system": "Système",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "saved": "Enregistré",
    "activated": "{{name}} activé",
    "deactivated": "{{name}} désactivé",
    "deleted": "{{name}} supprimé",
    "confirmDeleteTitle": "Supprimer {{name}} ?",
    "confirmDeleteText": "Cette valeur n'a jamais été utilisée : elle sera supprimée définitivement. La modification reste dans le journal d'activité.",
    "confirmDeactivateTitle": "Désactiver {{name}} ?",
    "confirmDeactivateText": "Elle reste sur les enregistrements passés mais ne peut plus être choisie. Vous pourrez la réactiver plus tard."
  },
  "units": {
    "title": "Unités de mesure",
    "add": "Ajouter une unité",
    "edit": "Modifier l'unité",
    "name": "Unité",
    "symbol": "Symbole",
    "decimals": "Décimales",
    "decimalsHint": "0 pour les pièces, jusqu'à {{max}} pour un poids ou une longueur.",
    "days": "jours"
  },
  "categories": {
    "title": "Catégories",
    "add": "Ajouter une catégorie",
    "edit": "Modifier la catégorie",
    "name": "Catégorie",
    "parent": "Catégorie parente",
    "noParent": "Aucune (premier niveau)",
    "children": "Sous-catégories",
    "empty": "Aucune catégorie pour l'instant.",
    "subtitle": "Comment les produits sont regroupés, en catégories et sous-catégories. La boutique en ligne et les rapports s'en servent.",
    "emptyHint": "Ajoutez une première catégorie, puis des sous-catégories dessous.",
    "search": "Chercher une catégorie",
    "noMatch": "Aucune catégorie ne porte ce nom.",
    "products": "Produits",
    "branch": "Avec sous-catégories",
    "seeProducts_one": "{{count}} produit",
    "seeProducts_many": "{{count}} produits",
    "seeProducts_other": "{{count}} produits",
    "addSub": "Sous-catégorie",
    "addSubFor": "Ajouter une sous-catégorie à {{name}}",
    "expand": "Afficher les sous-catégories de {{name}}",
    "collapse": "Masquer les sous-catégories de {{name}}",
    "expandAll": "Tout déplier",
    "collapseAll": "Tout replier"
  },
  "brands": {
    "title": "Marques",
    "add": "Ajouter une marque",
    "edit": "Modifier la marque",
    "name": "Marque",
    "empty": "Aucune marque pour l'instant.",
    "subtitle": "Les marques des produits. La liste des produits et la boutique en ligne filtrent par marque.",
    "emptyHint": "Ajoutez les marques que vous vendez ; un produit en prend une à sa création ou en modification.",
    "search": "Chercher une marque",
    "noMatch": "Aucune marque ne porte ce nom.",
    "products": "Produits"
  },
  "reasons": {
    "title": "Motifs d'ajustement",
    "add": "Ajouter un motif",
    "edit": "Modifier le motif",
    "name": "Motif",
    "direction": "Sens",
    "directions": {
      "increase": "Hausse",
      "decrease": "Baisse",
      "both": "Les deux"
    }
  },
  "options": {
    "title": "Options de produits",
    "subtitle": "Options réutilisables pour les produits à variantes : Couleur, Taille, Matière, Finition. Chaque produit choisit les valeurs qu'il propose.",
    "add": "Ajouter une option",
    "edit": "Modifier l'option",
    "name": "Nom",
    "presentation": "Affichage",
    "values": "Valeurs",
    "presentations": {
      "swatch": "Pastilles de couleur",
      "buttons": "Boutons",
      "dropdown": "Liste déroulante",
      "image": "Images"
    },
    "presentationHints": {
      "swatch": "Une pastille de couleur par valeur. Donnez sa couleur à chaque valeur.",
      "buttons": "Un bouton par valeur : idéal pour les tailles et les choix courts.",
      "dropdown": "Une liste à dérouler : idéale quand les valeurs sont nombreuses.",
      "image": "Une image par valeur (un motif, une texture). Ajoutez les images une fois l'option enregistrée."
    },
    "codeHint": "(le code entre dans la référence des variantes : PNT-10L-BLC)",
    "label": "Valeur",
    "code": "Code",
    "color": "Couleur de {{name}}",
    "active": "Active",
    "addValue": "Ajouter",
    "quickAdd": "Ajoutez-en plusieurs d'un coup : XS, S, M, L",
    "moveUp": "Monter",
    "moveDown": "Descendre",
    "remove": "Retirer {{name}}",
    "removeUsed_one": "Utilisée par {{count}} variante : désactivez-la plutôt",
    "removeUsed_other": "Utilisée par {{count}} variantes : désactivez-la plutôt",
    "noValues": "Aucune valeur pour le moment.",
    "more": "+{{count}}",
    "addPicture": "Image de {{name}}",
    "removePicture": "Retirer l'image de {{name}}",
    "pictureLater": "Enregistrez d'abord",
    "picturesAfterSave": "Enregistrez l'option, puis ajoutez une image à chaque valeur.",
    "empty": "Aucune option pour le moment. Ajoutez celles que proposent vos produits : Couleur, Taille, Finition..."
  },
  "attributes": {
    "title": "Attributs de produits",
    "subtitle": "Descriptions réutilisables qui ne créent pas de variantes : Poids, Dimensions, Étanche. Elles aident à trouver et comparer les produits.",
    "add": "Ajouter un attribut",
    "edit": "Modifier l'attribut",
    "name": "Nom",
    "type": "Type",
    "details": "Unité ou choix",
    "types": {
      "text": "Texte",
      "number": "Nombre",
      "boolean": "Oui ou non",
      "choice": "Choix dans une liste"
    },
    "unit": "Unité",
    "unitHint": "Affichée après le nombre : kg, mm, W.",
    "choices": "Choix",
    "choicesHint": "Un choix par ligne.",
    "empty": "Aucun attribut pour le moment. Ajoutez les informations à noter sur les produits : Poids, Dimensions..."
  },
  "salesRules": {
    "title": "Règles de vente",
    "subtitle": "Ce que les factures ajoutent, le délai des livreurs pour verser, la remise en caisse.",
    "stampDuty": "Timbre fiscal sur les factures",
    "stampDutyHint": "Ajouté une fois à chaque facture, après le total TTC.",
    "codDays": "Règlement du contre-remboursement",
    "codDaysHint": "Jours après la livraison avant qu’une commande non réglée lève une alerte.",
    "posDiscount": "Limite de remise des caissiers",
    "posDiscountHint": "La part d'un ticket qu'un caissier peut accorder en caisse. Au-delà, une personne autorisée aux fortes remises fait la vente."
  },
  "cashRules": {
    "title": "Caisses",
    "subtitle": "Comment les tiroirs sont comptés et quand les services doivent être fermés.",
    "denominations": "Billets et pièces",
    "denominationsHint": "Ceux comptés à l’ouverture et à la fermeture d’un service.",
    "denominationsRequired": "Gardez au moins un billet ou une pièce.",
    "varianceLimit": "Écart sans approbation",
    "varianceLimitHint": "Un comptage de fermeture plus éloigné que cela des espèces attendues attend un responsable.",
    "closeTime": "Heure de fermeture",
    "closeTimeHint": "Un service encore ouvert après cette heure lève une alerte.",
    "blind": "Comptage de fermeture à l’aveugle",
    "blindHint": "Les caissiers comptent le tiroir sans voir les espèces attendues ; les responsables les voient toujours."
  },
  "onlineStore": {
    "title": "Boutique en ligne",
    "subtitle": "Ce que les clients voient d’abord : le carrousel, les bannières et la page d’accueil de la boutique. Les changements y arrivent en moins d’une minute.",
    "carousel": {
      "title": "Carrousel",
      "description": "La première chose sous l’en-tête de la boutique : une photo à la fois, avec des flèches et des points. Chaque photo mène où vous voulez.",
      "add": "Ajouter une photo",
      "edit": "Modifier la photo",
      "empty": "Pas encore de photo",
      "emptyHint": "Sans photo active, la boutique n’affiche pas de carrousel et commence par les blocs ci-dessous."
    },
    "banners": {
      "title": "Bannières",
      "description": "La boutique affiche celles qui sont activées, et rien à la place des autres.",
      "deleteText": "Elle est supprimée définitivement, avec son image. Pour la remettre plus tard, désactivez-la plutôt. Le changement reste dans le journal d’activité.",
      "add": "Ajouter une bannière",
      "edit": "Modifier la bannière",
      "empty": "Pas encore de bannière",
      "emptyHint": "Tant que vous n’en ajoutez pas, le haut de la page d’accueil montre vos derniers articles, vos offres et vos catégories.",
      "scheduled": "Programmée",
      "ended": "Terminée",
      "from": "À partir du {{from}}",
      "until": "Jusqu’au {{to}}",
      "between": "Du {{from}} au {{to}}"
    },
    "placements": {
      "announcement": "Barre du haut",
      "carousel": "Carrousel",
      "hero": "Bannière principale",
      "tile": "Bannière latérale"
    },
    "placementHints": {
      "announcement": "Une ligne au-dessus de chaque page. Seule la première active s’affiche.",
      "carousel": "Le diaporama juste sous l’en-tête : une photo à la fois.",
      "hero": "La grande image de la page d’accueil. Plusieurs bannières défilent.",
      "tile": "Les deux petites images à côté. Sans elles, la bannière principale prend toute la largeur."
    },
    "form": {
      "placement": "Emplacement",
      "title": "Titre",
      "text": "Texte",
      "action": "Bouton",
      "actionHint": "Quelques mots, comme « Voir la collection ».",
      "language": "Langue",
      "allLanguages": "Toutes les langues",
      "picture": "Image",
      "pictureHint": "JPEG, PNG ou WebP, jusqu’à 5 Mo, large (1600 × 900). Le titre s’affiche dessus : sur téléphone, ses côtés sont coupés.",
      "photo": "Photo",
      "photoRequired": "Choisissez une photo.",
      "description": "Description",
      "descriptionHint": "Ce que montre la photo, pour les lecteurs d’écran et les moteurs de recherche.",
      "caption": "Légende",
      "captionHint": "Écrite sur la photo. Laissez vide si la photo porte déjà ses mots.",
      "link": "Ouvre",
      "noLink": "Rien",
      "category": "Catégorie",
      "brand": "Marque",
      "url": "Adresse web",
      "urlHint": "Une page de la boutique sans sa langue (/products/robe-lin), ou une adresse complète (https://…).",
      "startsOn": "Premier jour",
      "endsOn": "Dernier jour",
      "datesHint": "Vide : dès maintenant, sans fin.",
      "photoHint": "JPEG, PNG ou WebP, jusqu’à 5 Mo, très large (2100 × 900). Sur téléphone, ses côtés sont coupés.",
      "backgroundColor": "Couleur du fond",
      "textColor": "Couleur du texte",
      "barPreview": "Votre ligne de texte"
    },
    "links": {
      "products": "Tous les articles",
      "newest": "Nouveautés",
      "offers": "Offres",
      "category": "Une catégorie",
      "brand": "Une marque",
      "url": "Une adresse web"
    },
    "home": {
      "title": "Page d’accueil",
      "description": "Les blocs sous le carrousel, dans cet ordre.",
      "show": "Afficher {{name}}",
      "addCategory": "Ajouter les articles d’une catégorie",
      "add": "Ajouter",
      "chooseCategory": "Choisir une catégorie",
      "categorySection": "Articles : {{name}}",
      "unknownCategory": "Une catégorie qui n’existe plus",
      "remove": "Retirer {{name}}",
      "saved": "Page d’accueil enregistrée",
      "featuredAuto": "Automatique : les premiers articles du catalogue",
      "featuredChosen_one": "{{count}} article choisi",
      "featuredChosen_many": "{{count}} articles choisis",
      "featuredChosen_other": "{{count}} articles choisis",
      "choose": "Choisir les articles"
    },
    "featured": {
      "description": "Jusqu’à {{max}} articles, dans l’ordre où la boutique les montre. Sans aucun, elle montre les premiers articles du catalogue. Enregistrez la page d’accueil pour publier votre choix.",
      "none": "Aucun article choisi : la boutique montre les premiers articles du catalogue.",
      "find": "Chercher un article par nom ou code",
      "noMatch": "Aucun article de la boutique ne correspond.",
      "full": "{{max}} articles au plus : retirez-en un pour en ajouter un autre.",
      "notInStore": "Absent de la boutique",
      "add": "Ajouter {{name}}",
      "remove": "Retirer {{name}}"
    },
    "sections": {
      "hero": "Bannières",
      "categories": "Catégories",
      "featured": "Articles à la une",
      "newest": "Nouveautés",
      "offers": "Offres",
      "packs": "Packs",
      "category": "Articles d’une catégorie",
      "brands": "Marques",
      "assurances": "Livraison et paiement"
    }
  },
  "storeWebsites": {
    "title": "Boutique en ligne",
    "subtitle": "Les sites de votre boutique en ligne, autorisés à utiliser l’API de la boutique depuis un navigateur.",
    "none": "Aucun site pour l’instant : seuls le back-office et les serveurs appellent l’API de la boutique.",
    "add": "Site",
    "addHint": "Son adresse sans chemin, comme https://boutique.exemple.tn.",
    "addButton": "Ajouter",
    "remove": "Retirer",
    "apiHint": "L’API de la boutique est décrite dans docs/store-api.openapi.json (servie sous /store/v1)."
  },
  "supplierMethods": {
    "title": "Modes de paiement fournisseurs",
    "description": "Comment les fournisseurs sont payés. Les cinq premiers sont fournis et peuvent être renommés ; ajoutez les vôtres (une carte, un portefeuille mobile).",
    "add": "Ajouter un mode",
    "edit": "Modifier le mode",
    "name": "Mode",
    "kind": "Fonctionne comme",
    "kinds": {
      "cash": "Espèces",
      "transfer": "Virement bancaire",
      "cheque": "Chèque : numéro, banque, échéance",
      "kembiala": "Traite : numéro, banque, échéance",
      "deferred": "Crédit : une promesse jusqu’au paiement",
      "other": "Autre"
    },
    "usedBy_one": "{{count}} paiement",
    "usedBy_other": "{{count}} paiements"
  },
  "carriers": {
    "title": "Transporteurs",
    "description": "Les sociétés de livraison qui emportent vos colis. On les choisit sur les commandes à livrer, les canaux de vente et les versements des livreurs.",
    "add": "Ajouter un transporteur",
    "edit": "Modifier le transporteur",
    "name": "Transporteur",
    "phone": "Téléphone",
    "tracking": "Suivi",
    "hasTracking": "Lien de suivi",
    "trackingUrl": "Lien de suivi",
    "trackingHint": "La page colis du transporteur, avec {tracking} à la place du numéro de suivi, par exemple https://transporteur.tn/suivi?n={tracking}. Les commandes et les emails aux clients y renvoient alors.",
    "cash": "Contre-remboursement",
    "collects": "Encaisse",
    "noCash": "N’encaisse pas",
    "cashOnDelivery": "Encaisse le contre-remboursement",
    "cashOnDeliveryHint": "Il rapporte l’argent des commandes qu’il livre : il est proposé quand un livreur verse l’argent.",
    "usedBy_one": "{{count}} commande ou canal",
    "usedBy_many": "{{count}} commandes et canaux",
    "usedBy_other": "{{count}} commandes et canaux"
  },
  "labelSettings": {
    "title": "Étiquettes code-barres",
    "subtitle": "La taille et le contenu des étiquettes imprimées depuis les produits, les réceptions et les transferts. Chaque impression peut les modifier.",
    "preview": "Aperçu",
    "sampleName": "Abaya classique",
    "sampleOptions": "S / Noir",
    "invalid": "Vérifiez le format : étiquettes de 15 à 150 mm, jusqu’à 8 colonnes et 30 lignes.",
    "where": "Imprimez-les depuis un produit (« Imprimer des étiquettes »), une réception validée ou un transfert reçu. Imprimantes thermiques : réglez le papier du pilote à la taille de l’étiquette."
  },
  "catalogStore": {
    "photo": "Photo pour la boutique en ligne",
    "photoHint": "Affichée sur la page de la catégorie dans la boutique. JPEG, PNG ou WebP, 5 Mo au plus ; une image carrée ou paysage convient le mieux.",
    "logo": "Logo",
    "logoHint": "Affiché dans les marques de la boutique. JPEG, PNG ou WebP, 5 Mo au plus, sur fond clair.",
    "choose": "Choisir une image",
    "change": "Changer",
    "remove": "Retirer",
    "description": "Description",
    "descriptionHint": "Quelques lignes que la boutique en ligne affiche avec.",
    "website": "Site web",
    "slug": "Adresse",
    "slugHint": "La fin de l’adresse de sa page sur la boutique. La changer casse les anciens liens.",
    "slugAuto": "Vide : faite à partir du nom.",
    "shownOnline": "Visible dans la boutique en ligne",
    "categoryOnlineHint": "Désactivé : la boutique ne l’affiche plus parmi ses catégories, ni les catégories en dessous. Ses produits restent en vente.",
    "brandOnlineHint": "Désactivé : la boutique ne l’affiche plus parmi ses marques. Ses produits restent en vente.",
    "notOnline": "Hors boutique",
    "up": "Monter {{name}}",
    "down": "Descendre {{name}}"
  },
  "documentPrint": {
    "title": "Documents imprimés",
    "subtitle": "Ce que les factures, avoirs et bons de livraison affichent par défaut. Chaque impression peut le changer. Ce que la loi exige sur une facture s’imprime toujours : son numéro et sa date, les deux parties et leur matricule fiscal, les quantités, les montants et la TVA."
  }
}
